"use client";

import { authenticate } from "@/app/server/authenticate";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@workspace/ui/components/card";
import { OctagonAlertIcon } from "lucide-react";
import { signIn } from "next-auth/react";
import { useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";
import { useActionState, useEffect } from "react";
import { ZitadelSignInButton } from "./ZitadelSignInButton";
import { ZitadelSignUpButton } from "./ZitadelSignUpButton";

export function LoginForm({ className, ...props }: React.ComponentPropsWithoutRef<"div">) {
  const searchParams = useSearchParams();
  const [errorMessage, formAction, isPending] = useActionState(authenticate, undefined);
  const t = useTranslations("Login");

  useEffect(() => {
    if (searchParams.has("immediateLogin")) {
      signIn("zitadel", {
        redirectTo: "/"
      }).then(() => {
      });
    }
  }, [searchParams]);

  return (
    <Card className="w-96">
      <CardHeader>
        <CardTitle className="text-2xl">{t("title")}</CardTitle>
        <CardDescription>{t("description")}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex h-8 items-end space-x-1" aria-live="polite" aria-atomic="true">
          {errorMessage && (
            <>
              <OctagonAlertIcon className="size-5 text-red-500" />
              <p className="text-sm text-red-500">{errorMessage}</p>
            </>
          )}
        </div>

        <div className="flex flex-col gap-2">
          <ZitadelSignInButton />
          <ZitadelSignUpButton />
        </div>
      </CardContent>
    </Card>
  );
}
